import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    TemplateRef, ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { KalDialogConfig, KalDialogService } from '@kalidea/kaligraphi';
import { AllocationsContext } from 'src/app/_shared/services/allocations/detail/allocation.service';
import {
    SharedAllocationExecutionCode
} from 'src/app/_shared/stores/shared-allocation-execution/shared-allocation-execution.actions';
import {
    KeyValueModelDto,
    MoteurOperateurDto,
    MoteurRegleTypeDateRefDto,
    TypesRegleEnum
} from 'src/graphql/generated-types';
import { KalTableHeader } from 'src/app/_shared/modules/kal-table/classes/kal-table-header';
import {
    AdvancedRuleService,
    AdvancedRule,
    CritereModel,
    ParameterModel,
    RuleComputation
} from 'src/app/_shared/services/advanced-rule/advanced-rule.service';
import {
    ConfirmDialogComponent,
    ConfirmDialogData
} from 'src/app/_shared/dialogs/confirm-dialog/confirm-dialog.component';
import {
    SharedAdvancedRuleComputationDetailDialogComponent, SharedAdvancedRuleComputationDetailDialogData
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-computation-detail-dialog/shared-advanced-rule-computation-detail-dialog.component';

@Component({
    selector: 'app-shared-advanced-rule-detail-table',
    templateUrl: './shared-advanced-rule-detail-table.component.html',
    styleUrls: ['./shared-advanced-rule-detail-table.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAdvancedRuleDetailTableComponent implements OnInit {

    @Input()
    ruleList: AdvancedRule[];

    @Input()
    context: SharedAllocationExecutionCode;

    readonly columns: KalTableHeader<AdvancedRule>[] = [
        {code: 'IdOperateur', label: 'Et/Ou'},
        {code: 'ParentheseOuvrante', label: '('},
        {code: 'IdCritere', label: 'Critère'},
        {code: 'IdOperateurMolecule', label: 'Opérateur'},
        {code: 'Valeur', label: 'Valeur'},
        {code: 'Subvention', label: 'Subvention'},
        {code: 'SubventionDefaut', label: 'Subvention par défaut'},
        {code: 'SubventionGroupe', label: 'Subvention groupe'},
        {code: 'SubventionDefautGroupe', label: 'Subvention déf groupe'},
        {code: 'ParentheseFermante', label: ')'},
        {code: 'IdRegleApplication', label: "S'applique à"},
        {code: 'IdRegleNonApplication', label: "Ne s'applique pas à"},
        {code: 'IdTypeDate', label: 'Type date référence'},
    ];

    displayedColumns: string[] = [];

    operatorList: MoteurOperateurDto[] = [];

    criteriaList: CritereModel[] = [];

    applicationRuleList: KeyValueModelDto[] = [];

    dateTypeList: MoteurRegleTypeDateRefDto[] = [];

    private _ruleType: TypesRegleEnum;

    @ViewChild('criterionParametersTemplate') criterionParametersTemplate: TemplateRef<{ parameterList: ParameterModel }>;

    constructor(private readonly cdr: ChangeDetectorRef,
                private readonly advancedRuleService: AdvancedRuleService,
                private readonly dialogService: KalDialogService) {
    }

    get ruleType(): TypesRegleEnum {
        return this._ruleType;
    }

    @Input()
    set ruleType(type: TypesRegleEnum) {
        this._ruleType = type;

        this.displayedColumns = [
            'IdOperateur',
            'ParentheseOuvrante',
            'IdCritere',
            'IdOperateurMolecule',
            'Valeur',
            'ParentheseFermante',
            ...type === TypesRegleEnum.Subvention ? [
                'Subvention',
                'SubventionDefaut',
                'SubventionGroupe',
                'SubventionDefautGroupe'
            ] : [],
            ...[TypesRegleEnum.Accessibilite, TypesRegleEnum.Subvention].includes(type) ? [] : [
                'IdRegleApplication',
                'IdRegleNonApplication',
            ],
            'IdTypeDate',
        ];
        this.cdr.markForCheck();
    }

    get isArticle(): boolean {
        return this.context === AllocationsContext.ART;
    }

    openAdvancedComputingDetail(label: string, list: RuleComputation[]): void {
        this.dialogService.open(SharedAdvancedRuleComputationDetailDialogComponent, new KalDialogConfig<SharedAdvancedRuleComputationDetailDialogData>({
            title: `Détail du calcul avancé`,
            backdropClass: 'cdk-overlay-dark-backdrop',
            hasBackdrop: true,
            data: {
                label,
                computations: list
            }
        }));
    }

    openParametersDialog(criterionLabel: string, parameterList: ParameterModel[]): void {
        this.dialogService.open(ConfirmDialogComponent, new KalDialogConfig<ConfirmDialogData>({
            title: `Paramètres pour le critère "${criterionLabel}"`,
            backdropClass: 'cdk-overlay-dark-backdrop',
            hasBackdrop: true,
            data: {
                cancelLabel: 'Fermer',
                bodyTemplate: this.criterionParametersTemplate,
                bodyTemplateContext: {parameterList}
            }
        }));
    }

    ngOnInit(): void {
        this.operatorList = this.advancedRuleService.operatorList;
        this.criteriaList = this.advancedRuleService.criteriaList;

        this.applicationRuleList = this.advancedRuleService.applicationRuleList;
        this.dateTypeList = this.advancedRuleService.dateTypeList;
    }

}
